import events from 'events';

class EventEmitter extends events.EventEmitter {}

export default new EventEmitter();
